import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-279bb055"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lazy-component-placeholder"
}
const _hoisted_2 = {
  key: 1,
  class: "lazy-content",
  style: {"height":"100%"}
}

import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'lazy-component',
  props: {
  lazy: {
    type: Boolean,
    default: true
  },
  rootMargin: {
    type: String,
    default: '120px 0px'
  }
},
  emits: ['load'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const containerRef = ref<HTMLElement>()
const isLoaded = ref(!props.lazy)
let observer: IntersectionObserver | null = null
let scrollHandler: (() => void) | null = null
let resizeObserver: ResizeObserver | null = null
let fallbackTimer: ReturnType<typeof setTimeout> | null = null
let layoutRetryTimer: ReturnType<typeof setTimeout> | null = null

function checkIsInViewport () {
  if (!containerRef.value) return false
  const rect = containerRef.value.getBoundingClientRect()
  const windowHeight = window.innerHeight
  const windowWidth = window.innerWidth
  // 主内容区首帧可能宽度为 0，放宽为「与视口有交集」即可
  const hasSize = rect.width > 0 || rect.height > 0
  const intersectsViewport =
    rect.top < windowHeight && rect.bottom > 0 && rect.left < windowWidth && rect.right > 0
  return hasSize && intersectsViewport
}

/** 视口内或即将进入视口则加载（不依赖用户是否滚动过 window） */
function tryLoadIfVisible () {
  if (!containerRef.value || isLoaded.value) return
  if (checkIsInViewport()) {
    loadComponent()
  }
}

function handleScroll () {
  tryLoadIfVisible()
}

function handleIntersection (entries: IntersectionObserverEntry[]) {
  const entry = entries[0]
  if (!entry || !containerRef.value || isLoaded.value) return
  if (entry.isIntersecting && entry.intersectionRatio > 0) {
    loadComponent()
  }
}

function loadComponent () {
  if (isLoaded.value) return
  isLoaded.value = true
  emit('load')
  cleanup()
}

function cleanup () {
  if (observer && containerRef.value) {
    observer.unobserve(containerRef.value)
    observer.disconnect()
    observer = null
  }
  if (scrollHandler) {
    window.removeEventListener('scroll', scrollHandler, true)
    scrollHandler = null
  }
  if (resizeObserver && containerRef.value) {
    resizeObserver.unobserve(containerRef.value)
    resizeObserver.disconnect()
    resizeObserver = null
  }
  if (fallbackTimer != null) {
    clearTimeout(fallbackTimer)
    fallbackTimer = null
  }
  if (layoutRetryTimer != null) {
    clearTimeout(layoutRetryTimer)
    layoutRetryTimer = null
  }
}

function initObserver () {
  if (!containerRef.value || !props.lazy) return

  if (typeof IntersectionObserver === 'undefined') {
    isLoaded.value = true
    emit('load')
    return
  }

  if (checkIsInViewport()) {
    loadComponent()
    return
  }

  scrollHandler = handleScroll
  window.addEventListener('scroll', scrollHandler, { passive: true, capture: true })

  if (typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(() => {
      tryLoadIfVisible()
    })
    resizeObserver.observe(containerRef.value)
  }

  observer = new IntersectionObserver(handleIntersection, {
    rootMargin: props.rootMargin,
    threshold: [0, 0.01, 0.1]
  })

  observer.observe(containerRef.value)

  // 侧栏/路由动画结束后主区域尺寸变化，补一次可见性检测
  layoutRetryTimer = setTimeout(() => tryLoadIfVisible(), 300)

  // 极端情况下仍不触发 IO，避免永久占位
  fallbackTimer = setTimeout(() => {
    if (!isLoaded.value) loadComponent()
  }, 8000)
}

onMounted(() => {
  if (!props.lazy) {
    isLoaded.value = true
    emit('load')
    return
  }
  nextTick(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initObserver()
      })
    })
  })
})

onBeforeUnmount(() => {
  cleanup()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "lazy-component-wrap"
  }, [
    (!isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "placeholder", {}, () => [
            _createTextVNode("加载中...")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
  ], 512))
}
}

})